module.exports = __webpack_public_path__ + "img/12 LANDSCAPE.27a63fdc.png";